import { render, staticRenderFns } from "./RevalidateForm.vue?vue&type=template&id=49a47ca2"
import script from "./RevalidateForm.vue?vue&type=script&lang=js"
export * from "./RevalidateForm.vue?vue&type=script&lang=js"
import style0 from "./RevalidateForm.vue?vue&type=style&index=0&id=49a47ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports